import React from 'react'
// import loader from '../assets/images/loader.gif'

const Loader = () => {
  return (
    <>
    <div className="loader-sec">
        {/* <img src={loader} alt="" /> */}
        <div>Loading...</div>
    </div>
    </>
  )
}

export default Loader
